const isBrowser = () => typeof window !== 'undefined';

const getUser = () =>
  isBrowser() &&
  window.localStorage.getItem('thecrouser') &&
  window.localStorage.getItem('thecrouser');

const setUser = user =>
  user
    ? window.localStorage.setItem('thecrouser', user)
    : window.localStorage.removeItem('thecrouser');

const login = user => setUser(user);

const isLoggedIn = () => Boolean(getUser());

const logout = callback => {
  setUser();
  callback?.();
};

export default isLoggedIn;
export { isBrowser, getUser, login, logout };
